module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-row', {
    attrs: {
      "align-h": "between"
    }
  }, [_c('b-col', [_c('el-date-picker', {
    staticClass: "date-picker-inline",
    attrs: {
      "align": "right",
      "placeholder": "Na dzień"
    },
    model: {
      value: (_vm.reportDate),
      callback: function($$v) {
        _vm.reportDate = $$v
      },
      expression: "reportDate"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "text-right"
  }, [_c('b-button', {
    attrs: {
      "variant": "default"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.downloadReport()
      }
    }
  }, [_c('span', [_vm._v("Generuj XLS")]), _vm._v(" "), _c('svg-icon', {
    attrs: {
      "name": "download"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.loading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover table-clickable table-search"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Klient")]), _vm._v(" "), _c('th', [_vm._v("Kwota (" + _vm._s(_vm.currency.name) + ")")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.items.customers), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "td-no_link"
    }, [_vm._v(_vm._s(item.customerName))]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [_vm._v(_vm._s(item.amount) + " ")])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "tr-summary"
  }, [_c('td', {
    staticClass: "td-no_link text-right"
  }, [_vm._v("Razem")]), _vm._v(" "), _c('td', {
    staticClass: "td-no_link"
  }, [_c('strong', [_vm._v(_vm._s(_vm.items.total))])])])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34abca27","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/Debts.vue
// module id = 804
// module chunks = 0